export default __webpack_public_path__ + "static/viselli-48215cd1642931d90375b740952d74e4.jpg";